export const getValidationMessage = (validationMessages, field, validator, lang = 'en') => {
    if (!validationMessages[lang]) {
      console.warn(`Language ${lang} not found, falling back to English`);
      lang = 'en';
    }
    
    const fieldParts = field.split('.');
    let messageObj = validationMessages[lang];
    
    for (const part of fieldParts) {
      if (messageObj[part]) {
        messageObj = messageObj[part];
      } else {
        console.warn(`Field ${field} not found in validation messages`);
        return '';
      }
    }
    
    if (messageObj[validator]) {
      return messageObj[validator];
    }
    
    console.warn(`Validator ${validator} not found for field ${field}`);
    return '';
}; 